<script setup>
import ActionButton from '@/components/common/ActionButton.vue'

const props = defineProps({
  disabled: { default: false, type: Boolean },
  loadingGenerate: { default: false, type: Boolean },
  loadingDownload: { default: false, type: Boolean },
  loadingExport: { default: false, type: Boolean },
  loadingImport: { default: false, type: Boolean },
  loadingSave: { default: false, type: Boolean },
  importIcon: { required: false, default: 'mdi-upload' },
  downloadIcon: { required: false, default: 'mdi-download' },
  exportIcon: { required: false, default: 'mdi-export' },
  exportText: { required: false, default: 'Export' },
  downloadText: { required: false, default: 'Download' },
  importText: { required: false, default: 'Import' },
  loadingSaveAndGenerate: { default: false, type: Boolean },
  loadingAdd: { default: false, type: Boolean },
  disabledGenerate: { default: false, type: Boolean },
  disabledImport: { default: false, type: Boolean },
  disabledDownload: { default: false, type: Boolean },
  disabledExport: { default: false, type: Boolean },
  disabledSave: { default: false, type: Boolean },
  disabledSaveAndGenerate: { default: false, type: Boolean },
  disabledAdd: { default: false, type: Boolean },
  showGenerate: { default: false, type: Boolean },
  showImportRight: { default: false, type: Boolean },
  showExportRight: { default: false, type: Boolean },
  showDownloadRight: { default: false, type: Boolean },
  showImport: { default: false, type: Boolean },
  showSave: { default: false, type: Boolean },
  showSaveAndGenerate: { default: false, type: Boolean },
  showAdd: { default: false, type: Boolean },
  borderBottom: { default: false, type: Boolean }
})

defineEmits(['generate', 'import', 'save', 'save-generate', 'add', 'download', 'export'])

function shouldDisabled(value) {
  return props.disabled || value
}
</script>

<template>
  <div :class="`d-flex justify-space-between ${borderBottom ? 'border-bottom' : null}`">
    <div>
      <ActionButton
        v-if="showGenerate"
        :disabled="shouldDisabled(disabledGenerate)"
        :loading="loadingGenerate"
        @action="$emit('generate')"
        class="mr-2"
      >
        Generate
      </ActionButton>
      <ActionButton
        v-if="showImport"
        :disabled="shouldDisabled(disabledImport)"
        :loading="loadingImport"
        @action="$emit('import')"
      >
        Import
      </ActionButton>
      <slot name="left"> </slot>
    </div>
    <div class="float-right">
      <slot name="right"> </slot>

      <div>
        <slot name="next"> </slot>
        <ActionButton
          v-if="showSave"
          :disabled="shouldDisabled(disabledSave)"
          :loading="loadingSave"
          @action="$emit('save')"
        >
          Save
        </ActionButton>
        <ActionButton
          v-if="showSaveAndGenerate"
          :disabled="shouldDisabled(disabledSaveAndGenerate)"
          :loading="loadingSaveAndGenerate"
          @action="$emit('save-generate')"
          class="ml-2"
        >
          Save & Generate
        </ActionButton>
        <ActionButton
          v-if="showAdd"
          :disabled="shouldDisabled(disabledAdd)"
          :loading="loadingAdd"
          @action="$emit('add')"
          class="ml-2"
          prepend-icon="mdi-plus"
        >
          Add
        </ActionButton>
      </div>
      <div class="btn-container mt-2">
        <ActionButton
          :prepend-icon="importIcon"
          variant="outlined"
          v-if="showImportRight"
          :disabled="shouldDisabled(disabledImport)"
          :loading="loadingImport"
          @action="$emit('import')"
        >
          {{ importText }}
        </ActionButton>
        <ActionButton
          :prepend-icon="downloadIcon"
          variant="outlined"
          v-if="showDownloadRight"
          :disabled="shouldDisabled(disabledDownload)"
          :loading="loadingDownload"
          @action="$emit('download')"
        >
          {{ downloadText }}
        </ActionButton>
        <ActionButton
          :prepend-icon="exportIcon"
          variant="outlined"
          v-if="showExportRight"
          :disabled="shouldDisabled(disabledExport)"
          :loading="loadingExport"
          @action="$emit('export')"
        >
          {{ exportText }}
        </ActionButton>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton.vue'

export default {
  name: 'ActionBar',
  components: { ActionButton },
  props: {
    disabled: { default: false, type: Boolean },
    loadingGenerate: { default: false, type: Boolean },
    loadingDownload: { default: false, type: Boolean },
    loadingExport: { default: false, type: Boolean },
    loadingImport: { default: false, type: Boolean },
    loadingSave: { default: false, type: Boolean },
    importIcon: { required: false, default: 'mdi-upload' },
    downloadIcon: { required: false, default: 'mdi-download' },
    exportIcon: { required: false, default: 'mdi-export' },
    exportText: { required: false, default: 'Export' },
    downloadText: { required: false, default: 'Download' },
    importText: { required: false, default: 'Import' },
    loadingSaveAndGenerate: { default: false, type: Boolean },
    loadingAdd: { default: false, type: Boolean },
    disabledGenerate: { default: false, type: Boolean },
    disabledImport: { default: false, type: Boolean },
    disabledDownload: { default: false, type: Boolean },
    disabledExport: { default: false, type: Boolean },
    disabledSave: { default: false, type: Boolean },
    disabledSaveAndGenerate: { default: false, type: Boolean },
    disabledAdd: { default: false, type: Boolean },
    showGenerate: { default: false, type: Boolean },
    showImportRight: { default: false, type: Boolean },
    showExportRight: { default: false, type: Boolean },
    showDownloadRight: { default: false, type: Boolean },
    showImport: { default: false, type: Boolean },
    showSave: { default: false, type: Boolean },
    showSaveAndGenerate: { default: false, type: Boolean },
    showAdd: { default: false, type: Boolean },
    borderBottom: { default: false, type: Boolean }
  },
  methods: {
    shouldDisabled(value) {
      return this.disabled || value
    }
  }
}
</script>
<style scoped>
.border-bottom {
  z-index: 1;
  background-color: white;
  border-bottom: solid 1px rgb(0, 0, 0, 0.05);
}
</style>
